module.exports = __webpack_public_path__ + "img/image18.1b361fcd.jpg";